import { getTableau } from './init';
import type { Worksheet, DataTable, TableauEventUnregisterFn } from '@tableau/extensions-api-types';

export type SelectionChangedCallback = (marks: DataTable | null) => void;

let currentUnregister: TableauEventUnregisterFn | null = null;

export function findWorksheet(name: string): Worksheet | null {
  const tableau = getTableau();
  const dashboard = tableau.extensions.dashboardContent?.dashboard;
  if (!dashboard) return null;

  return dashboard.worksheets.find((ws: Worksheet) => ws.name === name) ?? null;
}

export function subscribeToSelectionChanges(
  worksheet: Worksheet,
  callback: SelectionChangedCallback
): void {
  if (currentUnregister) {
    currentUnregister();
    currentUnregister = null;
  }

  const tableau = getTableau();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUnregister = worksheet.addEventListener(
    tableau.TableauEventType.MarkSelectionChanged as any,
    async () => {
      const marks = await getSelectedMarks(worksheet);
      callback(marks);
    }
  );
}

export function unsubscribeFromSelectionChanges(): void {
  if (currentUnregister) {
    currentUnregister();
    currentUnregister = null;
  }
}

export async function getSelectedMarks(worksheet: Worksheet): Promise<DataTable | null> {
  const marksCollection = await worksheet.getSelectedMarksAsync();
  const data = marksCollection.data;

  if (data.length === 0) return null;

  const table = data[0];
  if (table.totalRowCount === 0) return null;

  return table;
}
